exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{background-color:white;padding:24px}.title{text-transform:uppercase;color:#848484;border-bottom:1px solid #f0f0f0;font-size:12px;margin-bottom:18px}.link{font-size:14px;margin-bottom:12px;line-height:1.2;display:block;text-decoration:none}.link:hover{text-decoration:underline}.link:last-child{margin-bottom:0}\n", ""]);

// exports
